var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLeftButtonChevron = function SvgLeftButtonChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.498,
    height: 13.27,
    viewBox: "0 0 7.498 13.27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M6.4,7.09a.886.886,0,0,1-.589-.242L.271,1.528A.889.889,0,0,1,1.5.247L6.429,4.978,11.354.247a.889.889,0,0,1,1.233,1.281L7.046,6.848A.886.886,0,0,1,6.4,7.09Z",
    transform: "translate(7.291 0.206) rotate(90)",
    strokeWidth: 0.4
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjQ5OCIgaGVpZ2h0PSIxMy4yNyIgdmlld0JveD0iMCAwIDcuNDk4IDEzLjI3Ij4NCiAgPHBhdGggaWQ9IlBhdGhfMTA4MiIgZGF0YS1uYW1lPSJQYXRoIDEwODIiIGQ9Ik02LjQsNy4wOWEuODg2Ljg4NiwwLDAsMS0uNTg5LS4yNDJMLjI3MSwxLjUyOEEuODg5Ljg4OSwwLDAsMSwxLjUuMjQ3TDYuNDI5LDQuOTc4LDExLjM1NC4yNDdhLjg4OS44ODksMCwwLDEsMS4yMzMsMS4yODFMNy4wNDYsNi44NDhBLjg4Ni44ODYsMCwwLDEsNi40LDcuMDlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjI5MSAwLjIwNikgcm90YXRlKDkwKSIgc3Ryb2tlLXdpZHRoPSIwLjQiLz4NCjwvc3ZnPg0KDQo=";
export { SvgLeftButtonChevron as ReactComponent };